<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Multiselect from "@vueform/multiselect";
import {} from 'devextreme-vue/data-grid';
import Loader from "@/router/views_mobagile/components/loader.vue";
import api from "@/axios";
import Swal from "sweetalert2";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Loader, Layout, PageHeader, Multiselect
  },
  data() {
    return {
      title: "Editar Movimento MDF-e (Fiscal)",
      items: [
        {
          text: "Movimentos MDF-e's (Fiscal)",
          href: "/movmdfesfiscal/list"
        },
        {
          text: "Editar Movimento MDF-e (Fiscal)",
          active: true
        }
      ],
      idData: 0,
      updating: false,
      errosValid: null,
      submitted: false,
      submittedObs: false,
      movMdfeFiscalData: {},
      dtListPesqEmit: null,
      visibleCola1: true,
      paramsEmissorOk: false,

      movMdfeFiscalMunCgs: null,
      movMdfeFiscalMunCg: {},
      showModalMunCg: false,
      submittedMunCg: false,
      dtListPesqCidade: null,
      movMdfeFiscalUfPers: null,
      movMdfeFiscalUfPer: {},
      showModalUfPer: false,
      submittedUfPer: false,
      movMdfeFiscalCiots: null,
      movMdfeFiscalCiot: {},
      showModalCiot: false,
      submittedCiot: false,
      movMdfeFiscalVPdgs: null,
      movMdfeFiscalVPdg: {},
      showModalVPdg: false,
      submittedVPdg: false,
      movMdfeFiscalConts: null,
      movMdfeFiscalCont: {},
      showModalCont: false,
      submittedCont: false,
      movMdfeFiscalVeics: null,
      movMdfeFiscalVeic: {},
      showModalVeic: false,
      submittedVeic: false,
      movMdfeFiscalLaRods: null,
      movMdfeFiscalLaRod: {},
      showModalLaRod: false,
      submittedLaRod: false,
      movMdfeFiscalMunDcgs: null,
      movMdfeFiscalMunDcg: {},
      showModalMunDcg: false,
      submittedMunDcg: false,
      movMdfeFiscalDocs: null,
      movMdfeFiscalDoc: {},
      showModalDoc: false,
      submittedDoc: false,
      movMdfeFiscalSegs: null,
      movMdfeFiscalSeg: {},
      showModalSeg: false,
      submittedSeg: false,
      movMdfeFiscalAutDs: null,
      movMdfeFiscalAutD: {},
      showModalAutD: false,
      submittedAutD: false,
      movMdfeFiscalProds: null,
      movMdfeFiscalProd: {},
      showModalProd: false,
      submittedProd: false,
      movMdfeFiscalPags: null,
      movMdfeFiscalPag: {},
      showModalPag: false,
      submittedPag: false,
      dtListPesqMov: null,
    };
  },

  created() {

  },

  mounted() {
    console.log('mounted_movmdfe_fiscal_editar_0')
    let rota = this.$route.path
    // console.log(rota)
    let ultimaBarra = rota.lastIndexOf('/')
    if (ultimaBarra) {
      this.idData = parseInt(rota.substring(ultimaBarra + 1))
    }
    console.log(`idData: ${this.idData}`)
    this.carregarDados()
  },

  methods: {

    pesqMovChave(evt){
      console.log('pesqMovChave')
      console.log(evt)
      let query = evt
      if (query.length > 1){

        if (this.movMdfeFiscalDoc.tipo === 'NFE') {
          api.get(`${getBaseUrl()}api/movpesq`, {
            params: { q: query }
          }).then((res) => {
            console.log('then axios')
            console.log(res.data)
            this.dtListPesqMov = res.data
          });
        } else if (this.movMdfeFiscalDoc.tipo === 'CTE') {
          api.get(`${getBaseUrl()}api/movctepesq`, {
            params: { q: query }
          }).then((res) => {
            console.log('then axios')
            console.log(res.data)
            this.dtListPesqMov = res.data
          });
        } else if (this.movMdfeFiscalDoc.tipo === 'MDFE') {
          api.get(`${getBaseUrl()}api/movmdfepesq`, {
            params: { q: query }
          }).then((res) => {
            console.log('then axios')
            console.log(res.data)
            this.dtListPesqMov = res.data
          });
        }
      }
    },


    editarMunCg(data){
      console.log('editarMunCg')
      this.movMdfeFiscalMunCg = data
      this.showModalMunCg = true
    },

    novoMunCg(){
      console.log('novoMunCg')
      this.visibleCola1 = false
      this.movMdfeFiscalMunCg = {}
      this.submittedMunCg = false
      this.showModalMunCg = true
    },

    confMunCg(){
      console.log('confMunCg')
      this.submittedMunCg = true
      if (this.movMdfeFiscalMunCg.cmun) {
        this.showModalMunCg = false
        this.updating = true
        this.dtListPesqCidade.forEach((cidade) => {
          // console.log(cidade)
          if (cidade.codigo === this.movMdfeFiscalMunCg.cmun) {
            this.movMdfeFiscalMunCg.xmun = cidade.descricao
          }
        })
        this.movMdfeFiscalMunCg.movmdfefis_id = this.idData
        api.post(`${getBaseUrl()}api/movmdfefismuncg`, {
          movMdfeFiscalMunCg: this.movMdfeFiscalMunCg
        }).then((res) => {
          console.log('then axios')
          this.updating = false
          console.log(res)
          this.carregarDados()
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
        })
      }
    },

    deletarMunCg(dataID){
      console.log('deletarMunCg')
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Município de Carregamento",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/movmdfefismuncg`, {
            params: {
              'iddata': dataID
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            this.carregarDados()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
          })
        }
      })
    },

    pesqCidade(evt){
      console.log('pesqpesqCidade')
      console.log(evt)
      let query = evt
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/cidpesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqCidade = res.data
        });
      }
    },


    editarUfPer(data){
      console.log('editarUfPer')
      this.movMdfeFiscalUfPer = data
      this.showModalUfPer = true
    },

    novaUfPer(){
      console.log('novaUfPer')
      this.visibleCola1 = false
      this.movMdfeFiscalUfPer = {}
      this.submittedUfPer = false
      this.showModalUfPer = true
    },

    confUfPer(){
      console.log('confUfPer')
      this.submittedUfPer = true
      if (this.movMdfeFiscalUfPer.estado) {
        this.showModalUfPer = false
        this.updating = true
        this.movMdfeFiscalUfPer.movmdfefis_id = this.idData
        api.post(`${getBaseUrl()}api/movmdfefisufper`, {
          movMdfeFiscalUfPer: this.movMdfeFiscalUfPer
        }).then((res) => {
          console.log('then axios')
          this.updating = false
          console.log(res)
          this.carregarDados()
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
        })
      }
    },

    deletarUfPer(dataID){
      console.log('deletarUfPer')
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Estado de Percurso",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/movmdfefisufper`, {
            params: {
              'iddata': dataID
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            this.carregarDados()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
          })
        }
      })
    },


    editarCiot(data){
      console.log('editarCiot')
      this.movMdfeFiscalCiot = data
      this.showModalCiot = true
    },

    novoCiot(){
      console.log('novoCiot')
      this.visibleCola1 = false
      this.movMdfeFiscalCiot = {}
      this.submittedCiot = false
      this.showModalCiot = true
    },

    confCiot(){
      console.log('confCiot')
      this.submittedCiot = true
      if (this.movMdfeFiscalCiot.ciot) {
        this.showModalCiot = false
        this.updating = true
        this.movMdfeFiscalCiot.movmdfefis_id = this.idData
        api.post(`${getBaseUrl()}api/movmdfefisciot`, {
          movMdfeFiscalCiot: this.movMdfeFiscalCiot
        }).then((res) => {
          console.log('then axios')
          this.updating = false
          console.log(res)
          this.carregarDados()
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
        })
      }
    },

    deletarCiot(dataID){
      console.log('deletarCiot')
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de CIOT",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/movmdfefisciot`, {
            params: {
              'iddata': dataID
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            this.carregarDados()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
          })
        }
      })
    },


    editarVpdg(data){
      console.log('editarVPdg')
      this.movMdfeFiscalVPdg = data
      this.showModalVPdg = true
    },

    novoVPdg(){
      console.log('novoVPdg')
      this.visibleCola1 = false
      this.movMdfeFiscalVPdg = {}
      this.submittedVPdg = false
      this.showModalVPdg = true
    },

    confVPdg(){
      console.log('confVPdg')
      this.submittedVPdg = true
      if (this.movMdfeFiscalVPdg.cnpjfor) {
        this.showModalVPdg = false
        this.updating = true
        this.movMdfeFiscalVPdg.movmdfefis_id = this.idData
        api.post(`${getBaseUrl()}api/movmdfefisvpdg`, {
          movMdfeFiscalVPdg: this.movMdfeFiscalVPdg
        }).then((res) => {
          console.log('then axios')
          this.updating = false
          console.log(res)
          this.carregarDados()
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
        })
      }
    },

    deletarVPdg(dataID){
      console.log('deletarVPdg')
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Vale Pedágio",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/movmdfefisvpdg`, {
            params: {
              'iddata': dataID
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            this.carregarDados()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
          })
        }
      })
    },


    editarCont(data){
      console.log('editarCont')
      this.movMdfeFiscalCont = data
      this.showModalCont = true
    },

    novoCont(){
      console.log('novoCont')
      this.visibleCola1 = false
      this.movMdfeFiscalCont = {}
      this.submittedCont = false
      this.showModalCont = true
    },

    confCont(){
      console.log('confCont')
      this.submittedCont = true
      if (this.movMdfeFiscalCont.cnpj) {
        this.showModalCont = false
        this.updating = true
        this.movMdfeFiscalCont.movmdfefis_id = this.idData
        api.post(`${getBaseUrl()}api/movmdfefiscont`, {
          movMdfeFiscalCont: this.movMdfeFiscalCont
        }).then((res) => {
          console.log('then axios')
          this.updating = false
          console.log(res)
          this.carregarDados()
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
        })
      }
    },

    deletarCont(dataID){
      console.log('deletarCont')
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Contratante",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/movmdfefiscont`, {
            params: {
              'iddata': dataID
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            this.carregarDados()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
          })
        }
      })
    },


    editarVeic(data){
      console.log('editarVeic')
      this.movMdfeFiscalVeic = data
      this.showModalVeic = true
    },

    novoVeic(){
      console.log('novoVeic')
      this.visibleCola1 = false
      this.movMdfeFiscalVeic = {}
      this.submittedVeic = false
      this.showModalVeic = true
    },

    confVeic(){
      console.log('confVeic')
      this.submittedVeic = true
      if (this.movMdfeFiscalVeic.tipo && this.movMdfeFiscalVeic.placa) {
        this.showModalVeic = false
        this.updating = true
        this.movMdfeFiscalVeic.movmdfefis_id = this.idData
        api.post(`${getBaseUrl()}api/movmdfefisveic`, {
          movMdfeFiscalVeic: this.movMdfeFiscalVeic
        }).then((res) => {
          console.log('then axios')
          this.updating = false
          console.log(res)
          this.carregarDados()
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
        })
      }
    },

    deletarVeic(dataID){
      console.log('deletarVeic')
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Veículo",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/movmdfefisveic`, {
            params: {
              'iddata': dataID
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            this.carregarDados()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
          })
        }
      })
    },



    editarLaRod(data){
      console.log('editarLaRod')
      this.movMdfeFiscalLaRod = data
      this.showModalLaRod = true
    },

    novoLaRod(){
      console.log('novoLaRod')
      this.visibleCola1 = false
      this.movMdfeFiscalLaRod = {}
      this.submittedLaRod = false
      this.showModalLaRod = true
    },

    confLaRod(){
      console.log('confLaRod')
      this.submittedLaRod = true
      if (this.movMdfeFiscalLaRod.lacre) {
        this.showModalLaRod = false
        this.updating = true
        this.movMdfeFiscalLaRod.movmdfefis_id = this.idData
        api.post(`${getBaseUrl()}api/movmdfefislarod`, {
          movMdfeFiscalLaRod: this.movMdfeFiscalLaRod
        }).then((res) => {
          console.log('then axios')
          this.updating = false
          console.log(res)
          this.carregarDados()
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
        })
      }
    },

    deletarLaRod(dataID){
      console.log('deletarLaRod')
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Lacre Rodoviário",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/movmdfefislarod`, {
            params: {
              'iddata': dataID
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            this.carregarDados()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
          })
        }
      })
    },



    editarMunDcg(data){
      console.log('editarMunDcg')
      this.movMdfeFiscalMunDcg = data
      this.showModalMunDcg = true
    },

    novoMunDcg(){
      console.log('novoMunDcg')
      this.visibleCola1 = false
      this.movMdfeFiscalMunDcg = {}
      this.submittedMunDcg = false
      this.showModalMunDcg = true
    },

    confMunDcg(){
      console.log('confMunDcg')
      this.submittedMunDcg = true
      if (this.movMdfeFiscalMunDcg.cmun && this.movMdfeFiscalMunDcg.nitem) {
        this.showModalMunDcg = false
        this.updating = true
        this.dtListPesqCidade.forEach((cidade) => {
          // console.log(cidade)
          if (cidade.codigo === this.movMdfeFiscalMunDcg.cmun) {
            this.movMdfeFiscalMunDcg.xmun = cidade.descricao
          }
        })
        this.movMdfeFiscalMunDcg.movmdfefis_id = this.idData
        api.post(`${getBaseUrl()}api/movmdfefismundcg`, {
          movMdfeFiscalMunDcg: this.movMdfeFiscalMunDcg
        }).then((res) => {
          console.log('then axios')
          this.updating = false
          console.log(res)
          this.carregarDados()
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
        })
      }
    },

    deletarMunDcg(dataID){
      console.log('deletarMunDcg')
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Município de Descarga",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/movmdfefismundcg`, {
            params: {
              'iddata': dataID
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            this.carregarDados()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })

          })
        }
      })
    },




    editarDoc(data){
      console.log('editarDoc')
      this.movMdfeFiscalDoc = data
      this.showModalDoc = true
    },

    novoDoc(){
      console.log('novoDoc')
      this.visibleCola1 = false
      this.movMdfeFiscalDoc = {
        'tipo': 'NFE'
      }
      this.submittedDoc = false
      this.showModalDoc = true
    },

    confDoc(){
      console.log('confDoc')
      this.submittedDoc = true
      if (this.movMdfeFiscalDoc.tipo && this.movMdfeFiscalDoc.chave) {
        this.showModalDoc = false
        this.updating = true
        this.movMdfeFiscalDoc.movmdfefis_id = this.idData
        api.post(`${getBaseUrl()}api/movmdfefisdoc`, {
          movMdfeFiscalDoc: this.movMdfeFiscalDoc
        }).then((res) => {
          console.log('then axios')
          this.updating = false
          console.log(res)
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
          this.carregarDados()
        })
      }
    },

    deletarDoc(dataID){
      console.log('deletarDoc')
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Documento",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/movmdfefisdoc`, {
            params: {
              'iddata': dataID
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            //this.atualizaDataList()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
            this.carregarDados()
          })
        }
      })
    },





    editarSeg(data){
      console.log('editarSeg')
      this.movMdfeFiscalSeg = data
      this.showModalSeg = true
    },

    novoSeg(){
      console.log('novoSeg')
      this.visibleCola1 = false
      this.movMdfeFiscalSeg = {}
      this.submittedSeg = false
      this.showModalSeg = true
    },

    confSeg(){
      console.log('confSeg')
      this.submittedSeg = true
      if (this.movMdfeFiscalSeg.respseg) {
        this.showModalSeg = false
        this.updating = true
        this.movMdfeFiscalSeg.movmdfefis_id = this.idData
        api.post(`${getBaseUrl()}api/movmdfefisseg`, {
          movMdfeFiscalSeg: this.movMdfeFiscalSeg
        }).then((res) => {
          console.log('then axios')
          this.updating = false
          console.log(res)
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
          this.carregarDados()
        })
      }
    },

    deletarSeg(dataID){
      console.log('deletarSeg')
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Seguro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/movmdfefisseg`, {
            params: {
              'iddata': dataID
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            //this.atualizaDataList()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
            this.carregarDados()
          })
        }
      })
    },



    editarAutD(data){
      console.log('editarAutD')
      this.movMdfeFiscalAutD = data
      this.showModalAutD = true
    },

    novoAutD(){
      console.log('novoAutD')
      this.visibleCola1 = false
      this.movMdfeFiscalAutD = {}
      this.submittedAutD = false
      this.showModalAutD = true
    },

    confAutD(){
      console.log('confAutD')
      this.submittedAutD = true
      if (this.movMdfeFiscalAutD.cnpj) {
        this.showModalAutD = false
        this.updating = true
        this.movMdfeFiscalAutD.movmdfefis_id = this.idData
        api.post(`${getBaseUrl()}api/movmdfefisautd`, {
          movMdfeFiscalAutD: this.movMdfeFiscalAutD
        }).then((res) => {
          console.log('then axios')
          this.updating = false
          console.log(res)
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
          this.carregarDados()
        })
      }
    },

    deletarAutD(dataID){
      console.log('deletarAutD')
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Autorizado Download",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/movmdfefisautd`, {
            params: {
              'iddata': dataID
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            //this.atualizaDataList()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
            this.carregarDados()
          })
        }
      })
    },

    editarProd(data){
      console.log('editarProd')
      this.movMdfeFiscalProd = data
      this.showModalProd = true
    },

    novoProd(){
      console.log('novoProd')
      this.visibleCola1 = false
      this.movMdfeFiscalProd = {}
      this.submittedProd = false
      this.showModalProd = true
    },

    confProd(){
      console.log('confProd')
      this.submittedProd = true
      if (this.movMdfeFiscalProd.tpcarga && this.movMdfeFiscalProd.xprod) {
        this.showModalProd = false
        this.updating = true
        this.movMdfeFiscalProd.movmdfefis_id = this.idData
        api.post(`${getBaseUrl()}api/movmdfefisprod`, {
          movMdfeFiscalProd: this.movMdfeFiscalProd
        }).then((res) => {
          console.log('then axios')
          this.updating = false
          console.log(res)
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
          this.carregarDados()
        })
      }
    },

    deletarProd(dataID){
      console.log('deletarProd')
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Produto Predominante",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/movmdfefisprod`, {
            params: {
              'iddata': dataID
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            //this.atualizaDataList()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
            this.carregarDados()
          })
        }
      })
    },

    editarPag(data){
      console.log('editarPag')
      this.movMdfeFiscalPag = data
      this.showModalPag = true
    },

    novoPag(){
      console.log('novoPag')
      this.visibleCola1 = false
      this.movMdfeFiscalPag = {}
      this.submittedPag = false
      this.showModalPag = true
    },

    confPag(){
      console.log('confPag')
      this.submittedPag = true
      if (this.movMdfeFiscalPag.nome) {
        this.showModalPag = false
        this.updating = true
        this.movMdfeFiscalPag.movmdfefis_id = this.idData
        api.post(`${getBaseUrl()}api/movmdfefispag`, {
          movMdfeFiscalPag: this.movMdfeFiscalPag
        }).then((res) => {
          console.log('then axios')
          this.updating = false
          console.log(res)
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
          this.carregarDados()
        })
      }
    },

    deletarPag(dataID){
      console.log('deletarPag')
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Pagamento",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/movmdfefispag`, {
            params: {
              'iddata': dataID
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            //this.atualizaDataList()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
            this.carregarDados()
          })
        }
      })
    },




    validarMdfeSefaz() {
      console.log('validarMdfeSefaz')
      let validDoc = false
      if (this.movMdfeFiscalDocs) {
        this.movMdfeFiscalDocs.forEach((doc) => {
          console.log(doc)
          validDoc = true
        });
      }
      if (validDoc === false) {
        Swal.fire({
          text: "Favor incluir algum documento e tentar novamente",
          icon: "warning",
          position: "top-end",
          showConfirmButton: false,
          timer: 3500
        })
      } else {
        if (!this.movMdfeFiscalData.vcarga || !this.movMdfeFiscalData.cunid) {
          Swal.fire({
            text: "Favor preencher os campos Unidade e Valor de Carga, e tentar novamente",
            icon: "warning",
            position: "top-end",
            showConfirmButton: false,
            timer: 3500
          })
        } else {
          this.updating = true
          api.get(`${getBaseUrl()}api/movmdfevalmdfe`, {
            params: { iddata: this.idData }
          }).then((res) => {
            console.log(res.data)
            if (res.data[0] === 'erro') {
              Swal.fire({
                text: res.data[1],
                icon: "warning",
                position: "top-end",
                showConfirmButton: false,
                timer: 3500
              })
            } else {
              console.log('validacao_ok')
              // var blob = new Blob(res.data[1], {type: "text/plain;charset=utf-8"});
              // saveAs.saveAs([res.data[1]], "cte_teste.xml");

              Swal.fire({
                text: res.data[0],
                icon: "success",
                position: "top-end",
                showConfirmButton: false,
                timer: 2500
              })

            }
            this.updating = false
          })
        }
      }
    },

    validarSefazStatus(){
      console.log('validarSefazStatus')
      this.updating = true
      api.get(`${getBaseUrl()}api/movmdfefisvalsef`, {
        params: { iddata: this.idData }
      }).then((res) => {
        console.log(res.data)
        if (res.data[0] === 'erro') {
          Swal.fire({
            text: res.data[1],
            icon: "warning",
            position: "top-end",
            showConfirmButton: false,
            timer: 2500
          })
        } else {
          console.log('validacao_ok')
          Swal.fire({
            text: res.data[0],
            icon: "success",
            position: "top-end",
            showConfirmButton: false,
            timer: 2500
          })
        }
        this.updating = false
      })
    },

    carregarDados(){
      this.updating = true
      if (this.idData > 0){
        api.get(`${getBaseUrl()}api/movmdfefis`, {
          params: { iddata: this.idData }
        }).then((res) => {
          console.log(res.data)
          if (res.data.error){
            console.log(res.data.error)
            this.$router.push(`/faltapermissao`);
          }else{
            console.log('then axios')
            console.log(res.data)
            this.movMdfeFiscalData = res.data[0]
            this.movMdfeFiscalUfPers = res.data[1]
            this.movMdfeFiscalMunCgs = res.data[2]
            this.movMdfeFiscalCiots = res.data[3]
            this.movMdfeFiscalVPdgs = res.data[4]
            this.movMdfeFiscalConts = res.data[5]
            this.movMdfeFiscalVeics = res.data[6]
            this.movMdfeFiscalLaRods = res.data[7]
            this.movMdfeFiscalMunDcgs = res.data[8]
            this.movMdfeFiscalDocs = res.data[9]
            this.movMdfeFiscalSegs = res.data[10]
            this.movMdfeFiscalAutDs = res.data[11]
            this.movMdfeFiscalProds = res.data[12]
            this.movMdfeFiscalPags = res.data[13]
            if (this.movMdfeFiscalData.emit){
              this.dtListPesqEmit = [
                {
                  'codigo': this.movMdfeFiscalData.emit,
                  'nome': this.movMdfeFiscalData.emitnome,
                }
              ]
            }
            this.updating = false
            this.paramsEmissorOk = true
          }
        });
      }else{
        this.title = `Criando Novo Movimento MDF-e (Fiscal)`
        api.get(`${getBaseUrl()}api/movmdfefisnv`, {
          params: { iddata: this.idData }
        }).then((res) => {
          console.log('res.data')
          console.log(res.data)

          if (res.data[0] === 'erro') {
            Swal.fire({
              text: res.data[1],
              icon: "warning",
              position: "top-end",
              showConfirmButton: false,
              timer: 2500
            })
            this.paramsEmissorOk = false
          } else {
            this.movMdfeFiscalData = res.data[0]
            if (this.movMdfeFiscalData.emit){
              this.dtListPesqEmit = [
                {
                  'codigo': this.movMdfeFiscalData.emit,
                  'nome': this.movMdfeFiscalData.emitnome,
                }
              ]
            }
            this.paramsEmissorOk = true
          }
          this.updating = false
        })
      }
    },


    formSubmit(){
      console.log('formSubmit')
      this.submitted = true;
      if (this.movMdfeFiscalData.nmdf) {
        this.updating = true

        api.post(`${getBaseUrl()}api/movmdfefis`, {
          movMdfeFiscalData: this.movMdfeFiscalData
        }).then((res) => {
          console.log('then axios')
          this.updating = false
          console.log(res)
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
          if (this.idData === 0){
            this.idData = res.data[0].id
            this.movMdfeFiscalData = res.data[0]
            this.$router.replace('/movmdfefiscal/editar/' + this.idData)
          }

        }).catch((err) => {
          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false
        })
      }
    },

    pesqEmitente(evt) {
      console.log('pesqEmitente')
      console.log(evt)
      let query = evt
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/clipesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqEmit = res.data
        });
      }
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },

  },

};

</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />




    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-start">


              <b-button variant="outline-primary" class="mx-2" @click="formSubmit" :disabled="updating || !paramsEmissorOk">
                <i class="bx bx-save font-size-16 align-middle me-2"></i>
                Salvar Alterações
              </b-button>



              <b-button variant="outline-warning" class="mx-2" @click="validarSefazStatus" :disabled="updating" v-if="movMdfeFiscalData.id > 0">
                <i class="bx bx-check-circle font-size-16 align-middle me-2"></i>
                Validar Status Sefaz
              </b-button>

              <b-button variant="outline-secondary" class="mx-2" @click="validarMdfeSefaz" :disabled="updating" v-if="movMdfeFiscalData.id > 0">
                <i class="bx bx-send font-size-16 align-middle me-2"></i>
                Enviar MDF-e Sefaz
              </b-button>




            </div>
          </div>
        </div>
      </div>
    </div>

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>

    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`" show dismissible variant="danger">
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>

    <div class="checkout-tabs" v-if="!updating && paramsEmissorOk">
      <form class="needs-validation" @submit.prevent="formSubmit">


        <div class="card">
          <div class="card-body">

            <b-card-header header-tag="header" role="tab">
              <h6 class="m-0">
                <a v-b-toggle.accordion-1 class="text-dark" href="javascript: void(0);">Informações Principais</a>
              </h6>
            </b-card-header>
            <b-collapse id="accordion-1" v-model="visibleCola1" accordion="my-accordion-1" role="tabpanel">
              <b-card-body>

                <div class="row mb-2">

                  <div class="col-sm-2">
                    <div class="mb-3">
                      <label for="nmdf">Número MDF-e</label>
                      <input id="nmdf"
                             v-model="movMdfeFiscalData.nmdf"
                             type="text"
                             class="form-control"
                             :disabled="true"
                             :class="{'is-invalid': submitted && !movMdfeFiscalData.nmdf}"
                             placeholder="Número do documento fiscal" />
                      <div v-if="submitted && !movMdfeFiscalData.nmdf" class="invalid-feedback">
                        <span>Campo Número do documento obrigatório, favor preencher.</span>
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-2">
                    <div class="mb-3">
                      <label for="serie">Série</label>
                      <input id="serie"
                             v-model="movMdfeFiscalData.serie"
                             type="text"
                             :disabled="true"
                             class="form-control"
                             placeholder="Série do MDF-e" />
                    </div>
                  </div>

                  <div class="col-sm-4">
                    <div class="mb-3">
                      <label for="chave">Chave</label>
                      <input id="chave"
                             v-model="movMdfeFiscalData.chave"
                             type="text"
                             :disabled="true"
                             class="form-control"
                             placeholder="Chave" />
                    </div>
                  </div>

                  <div class="col-sm-2">
                    <div class="mb-3">
                      <label for="dhemi">Emissão</label>
                      <input id="dhemi"
                             v-model="movMdfeFiscalData.dhemi"
                             type="datetime-local"
                             class="form-control"
                             :disabled="true"
                             placeholder="Data de Emissão" />
                    </div>
                  </div>


                  <div class="col-sm-2">
                    <div class="mb-3">
                      <label for="tptransp">Tipo Transportador</label>
                      <select id="tptransp" v-model="movMdfeFiscalData.tptransp" class="form-control">
                        <option :value="null" disabled>Tipo do Transportador</option>
                        <option value="1">ETC</option>
                        <option value="2">TAC</option>
                        <option value="3">CTC</option>
                      </select>

                    </div>
                  </div>

                </div>


                <div class="row mb-2">

                  <div class="col-md-4">
                    <div class="mb-3">
                      <div class="mb-2">
                        <span class="text-black font-18 ">Emitente</span>
                      </div>
                      <multiselect id="inputEmitente"
                                   :disabled="true"
                                   @search-change="pesqEmitente"
                                   v-model="movMdfeFiscalData.emit"
                                   placeholder="Pesquisar Emitente"
                                   :options="dtListPesqEmit"
                                   :searchable="true"
                                   label="nome"
                                   class="multiselect-size"
                                   track-by="nome"
                                   value-prop="codigo">
                        <template #option="slotProps">
                          <div class="row">
                            <div>
                              <span class="text-info">
                                {{ slotProps.option.codigo }}
                              </span>
                              <span class="mx-4" >
                                {{ slotProps.option.cnpj }}
                              </span>
                            </div>
                            <div class="mt-2 font-size-16">{{ slotProps.option.nome }}</div>
                            <div class="align-items-end text-end align-content-end">{{ slotProps.option.cidade }} - {{ slotProps.option.estado }}</div>
                          </div>
                        </template>
                      </multiselect>
                    </div>
                  </div>



                  <div class="col-sm-2">
                    <div class="mb-3">
                      <label for="qcarga">Quant.Carga</label>
                      <input id="qcarga"
                             v-model="movMdfeFiscalData.qcarga"
                             type="number"
                             class="form-control"
                             placeholder="Quant.Carga" />
                    </div>
                  </div>


                  <div class="col-sm-2">
                    <div class="mb-3">
                      <label for="cunid">Unidade</label>
                      <input id="cunid"
                             v-model="movMdfeFiscalData.cunid"
                             type="text"
                             class="form-control"
                             placeholder="Unidade" />
                    </div>
                  </div>


                  <div class="col-sm-2">
                    <div class="mb-3">
                      <label for="vcarga">Valor Carga</label>
                      <input id="vcarga"
                             v-model="movMdfeFiscalData.vcarga"
                             type="number"
                             class="form-control"
                             placeholder="Valor Carga" />
                    </div>
                  </div>

                </div>


                <div class="row mb-2">




                </div>


              </b-card-body>

            </b-collapse>
          </div>
        </div>


        <div class="row">
          <div class="card col-md-12">
            <div class="card-body">
              <b-card-header header-tag="header" role="tab">
                <div class="row mb-2">
                  <div class="col-md-6">
                    <h6 class="m-0">
                      <a v-b-toggle.accordion-10
                         class="text-dark"
                         href="javascript: void(0);">
                        Documentos(s)
                      </a>
                    </h6>
                  </div>
                  <div class="col-md-6 text-end">
                    <b-button variant="outline-success" class="mx-2" @click="novoDoc" :disabled="updating" v-if="movMdfeFiscalData.id > 0">
                      <i class="bx bx-plus font-size-16 align-middle me-2"></i>
                      Novo Documento
                    </b-button>
                  </div>
                </div>

              </b-card-header>
              <b-collapse id="accordion-10" visible accordion="my-accordion-10" role="tabpanel">
                <b-card-body>
                  <div class="row mb-4">
                    <div class="table-responsive">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col">Item</th>
                          <th scope="col">Tipo</th>
                          <th scope="col">Chave</th>
                          <th scope="col">Tipo Transp</th>
                          <th scope="col">ID Transp</th>
                          <th scope="col">Tipo Carga</th>
                          <th scope="col">ID Carga</th>

                          <th scope="col" class="text-end">Ações</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="data in movMdfeFiscalDocs" :key="data.id">
                          <td>
                            <h5 class="font-size-14 text-truncate" @click="editarDoc(data)">
                              <span class="text-dark">
                                {{ data.id }}
                              </span>
                            </h5>
                          </td>
                          <td>
                            <h5 class="font-size-14 text-truncate" @click="editarDoc(data)">
                              <span class="text-dark">
                                {{ data.nitem }}
                              </span>
                            </h5>
                          </td>
                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span>
                                {{ data.tipo }}
                              </span>
                            </h5>
                          </td>
                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span>
                                {{ data.chave }}
                              </span>
                            </h5>
                          </td>
                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span>
                                {{ data.tpuntransp }}
                              </span>
                            </h5>
                          </td>
                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span>
                                {{ data.iduntransp }}
                              </span>
                            </h5>
                          </td>
                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span>
                                {{ data.tpuncarga }}
                              </span>
                            </h5>
                          </td>
                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span>
                                {{ data.iduncarga }}
                              </span>
                            </h5>
                          </td>

                          <td class="text-end">
                            <div class="button-items">
                              <b-button variant="outline-warning" @click="editarDoc(data)">
                                <i class="mdi mdi-pencil d-block font-size-16"></i>
                              </b-button>
                              <b-button variant="outline-danger" @click="deletarDoc(data.id)">
                                <i class="mdi mdi-trash-can d-block font-size-16"></i>
                              </b-button>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </b-card-body>
              </b-collapse>
            </div>
          </div>

        </div>



        <div class="row">


          <div class="card col-md-6">
            <div class="card-body">
              <b-card-header header-tag="header" role="tab">
                <div class="row mb-2">
                  <div class="col-md-6">
                    <h6 class="m-0">
                      <a v-b-toggle.accordion-2
                         class="text-dark"
                         href="javascript: void(0);">
                        Município(s) de Carregamento(s)
                      </a>
                    </h6>
                  </div>
                  <div class="col-md-6 text-end">
                    <b-button variant="outline-success" class="mx-2" @click="novoMunCg" :disabled="updating" v-if="movMdfeFiscalData.id > 0">
                      <i class="bx bx-plus font-size-16 align-middle me-2"></i>
                      Novo Município de Carregamento
                    </b-button>
                  </div>
                </div>
              </b-card-header>
              <b-collapse id="accordion-2" visible accordion="my-accordion-2" role="tabpanel">
                <b-card-body>
                  <div class="row mb-4">
                    <div class="table-responsive">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col">Código</th>
                          <th scope="col">Nome</th>
                          <th scope="col" class="text-end">Ações</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="data in movMdfeFiscalMunCgs" :key="data.id">
                          <td>
                            <h5 class="font-size-14 text-truncate" @click="editarUfPer(data)">
                              <span class="text-dark">
                                {{ data.id }}
                              </span>
                            </h5>
                          </td>
                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span>
                                {{ data.cmun }}
                              </span>
                            </h5>
                          </td>
                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span class="text-dark">
                                {{ data.xmun }}
                              </span>
                            </h5>
                          </td>

                          <td class="text-end">
                            <div class="button-items">
                              <b-button variant="outline-warning" @click="editarMunCg(data)">
                                <i class="mdi mdi-pencil d-block font-size-16"></i>
                              </b-button>
                              <b-button variant="outline-danger" @click="deletarMunCg(data.id)">
                                <i class="mdi mdi-trash-can d-block font-size-16"></i>
                              </b-button>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </b-card-body>
              </b-collapse>
            </div>
          </div>


          <div class="card col-md-6">
            <div class="card-body">
              <b-card-header header-tag="header" role="tab">
                <div class="row mb-2">
                  <div class="col-md-6">
                    <h6 class="m-0">
                      <a v-b-toggle.accordion-9
                         class="text-dark"
                         href="javascript: void(0);">
                        Município(s) de Descarregamento(s)
                      </a>
                    </h6>
                  </div>
                  <div class="col-md-6 text-end">
                    <b-button variant="outline-success" class="mx-2" @click="novoMunDcg" :disabled="updating" v-if="movMdfeFiscalData.id > 0">
                      <i class="bx bx-plus font-size-16 align-middle me-2"></i>
                      Novo Município de Descarregamento
                    </b-button>
                  </div>
                </div>
              </b-card-header>
              <b-collapse id="accordion-9" visible accordion="my-accordion-9" role="tabpanel">
                <b-card-body>
                  <div class="row mb-4">
                    <div class="table-responsive">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col">Código</th>
                          <th scope="col">Nome</th>
                          <th scope="col">Número Item</th>
                          <th scope="col" class="text-end">Ações</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="data in movMdfeFiscalMunDcgs" :key="data.id">
                          <td>
                            <h5 class="font-size-14 text-truncate" @click="editarMunDcg(data)">
                              <span class="text-dark">
                                {{ data.id }}
                              </span>
                            </h5>
                          </td>
                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span class="text-dark">
                                {{ data.cmun }}
                              </span>
                            </h5>
                          </td>
                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span class="text-dark">
                                {{ data.xmun }}
                              </span>
                            </h5>
                          </td>

                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span class="text-dark">
                                {{ data.nitem }}
                              </span>
                            </h5>
                          </td>

                          <td class="text-end">
                            <div class="button-items">
                              <b-button variant="outline-warning" @click="editarMunDcg(data)">
                                <i class="mdi mdi-pencil d-block font-size-16"></i>
                              </b-button>
                              <b-button variant="outline-danger" @click="deletarMunDcg(data.id)">
                                <i class="mdi mdi-trash-can d-block font-size-16"></i>
                              </b-button>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </b-card-body>
              </b-collapse>
            </div>
          </div>


        </div>






        <div class="row">

          <div class="card col-md-6">
            <div class="card-body">
              <b-card-header header-tag="header" role="tab">
                <div class="row mb-2">
                  <div class="col-md-6">
                    <h6 class="m-0">
                      <a v-b-toggle.accordion-3
                         class="text-dark"
                         href="javascript: void(0);">
                        Estado(s) do Percurso
                      </a>
                    </h6>
                  </div>
                  <div class="col-md-6 text-end">
                    <b-button variant="outline-success" class="mx-2" @click="novaUfPer" :disabled="updating" v-if="movMdfeFiscalData.id > 0">
                      <i class="bx bx-plus font-size-16 align-middle me-2"></i>
                      Novo Estado de Percurso
                    </b-button>
                  </div>
                </div>
              </b-card-header>
              <b-collapse id="accordion-3" visible accordion="my-accordion-3" role="tabpanel">
                <b-card-body>
                  <div class="row mb-4">
                    <div class="table-responsive">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col">Estado</th>
                          <th scope="col" class="text-end">Ações</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="data in movMdfeFiscalUfPers" :key="data.id">
                          <td>
                            <h5 class="font-size-14 text-truncate" @click="editarUfPer(data)">
                            <span class="text-dark">
                              {{ data.id }}
                            </span>
                            </h5>
                          </td>
                          <td>
                            <h5 class="font-size-14 text-truncate">
                            <span class="text-dark">
                              {{ data.estado }}
                            </span>
                            </h5>
                          </td>

                          <td class="text-end">
                            <div class="button-items">
                              <b-button variant="outline-warning" @click="editarUfPer(data)">
                                <i class="mdi mdi-pencil d-block font-size-16"></i>
                              </b-button>
                              <b-button variant="outline-danger" @click="deletarUfPer(data.id)">
                                <i class="mdi mdi-trash-can d-block font-size-16"></i>
                              </b-button>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </b-card-body>
              </b-collapse>
            </div>
          </div>



          <div class="card col-md-6">
            <div class="card-body">
              <b-card-header header-tag="header" role="tab">
                <div class="row mb-2">
                  <div class="col-md-6">
                    <h6 class="m-0">
                      <a v-b-toggle.accordion-6
                         class="text-dark"
                         href="javascript: void(0);">
                        Contratante(s)
                      </a>
                    </h6>
                  </div>
                  <div class="col-md-6 text-end">
                    <b-button variant="outline-success" class="mx-2" @click="novoCont" :disabled="updating" v-if="movMdfeFiscalData.id > 0">
                      <i class="bx bx-plus font-size-16 align-middle me-2"></i>
                      Novo Contratante
                    </b-button>
                  </div>
                </div>
              </b-card-header>
              <b-collapse id="accordion-6" visible accordion="my-accordion-6" role="tabpanel">
                <b-card-body>
                  <div class="row mb-4">
                    <div class="table-responsive">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col">CNPJ</th>
                          <th scope="col" class="text-end">Ações</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="data in movMdfeFiscalConts" :key="data.id">
                          <td>
                            <h5 class="font-size-14 text-truncate" @click="editarCont(data)">
                            <span class="text-dark">
                              {{ data.id }}
                            </span>
                            </h5>
                          </td>
                          <td>
                            <h5 class="font-size-14 text-truncate">
                            <span>
                              {{ data.cnpj }}
                            </span>
                            </h5>
                          </td>

                          <td class="text-end">
                            <div class="button-items">
                              <b-button variant="outline-warning" @click="editarCont(data)">
                                <i class="mdi mdi-pencil d-block font-size-16"></i>
                              </b-button>
                              <b-button variant="outline-danger" @click="deletarCont(data.id)">
                                <i class="mdi mdi-trash-can d-block font-size-16"></i>
                              </b-button>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </b-card-body>
              </b-collapse>
            </div>
          </div>
        </div>




        <div class="row">
          <div class="card col-md-6">
            <div class="card-body">
              <b-card-header header-tag="header" role="tab">
                <div class="row mb-2">
                  <div class="col-md-6">
                    <h6 class="m-0">
                      <a v-b-toggle.accordion-4
                         class="text-dark"
                         href="javascript: void(0);">
                        CIOT(s) (Código Identificador da Operação de Transporte)
                      </a>
                    </h6>
                  </div>
                  <div class="col-md-6 text-end">
                    <b-button variant="outline-success" class="mx-2" @click="novoCiot" :disabled="updating" v-if="movMdfeFiscalData.id > 0">
                      <i class="bx bx-plus font-size-16 align-middle me-2"></i>
                      Novo CIOT
                    </b-button>
                  </div>
                </div>
              </b-card-header>
              <b-collapse id="accordion-4" visible accordion="my-accordion-4" role="tabpanel">
                <b-card-body>
                  <div class="row mb-4">
                    <div class="table-responsive">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col">CIOT</th>
                          <th scope="col">CPF</th>
                          <th scope="col">CNPJ</th>
                          <th scope="col" class="text-end">Ações</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="data in movMdfeFiscalCiots" :key="data.id">
                          <td>
                            <h5 class="font-size-14 text-truncate" @click="editarCiot(data)">
                              <span class="text-dark">
                                {{ data.id }}
                              </span>
                            </h5>
                          </td>
                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span>
                                {{ data.ciot }}
                              </span>
                            </h5>
                          </td>
                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span class="text-dark">
                                {{ data.cpf }}
                              </span>
                            </h5>
                          </td>
                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span class="text-dark">
                                {{ data.cnpj }}
                              </span>
                            </h5>
                          </td>

                          <td class="text-end">
                            <div class="button-items">
                              <b-button variant="outline-warning" @click="editarCiot(data)">
                                <i class="mdi mdi-pencil d-block font-size-16"></i>
                              </b-button>
                              <b-button variant="outline-danger" @click="deletarCiot(data.id)">
                                <i class="mdi mdi-trash-can d-block font-size-16"></i>
                              </b-button>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </b-card-body>
              </b-collapse>
            </div>
          </div>


          <div class="card col-md-6">
            <div class="card-body">
              <b-card-header header-tag="header" role="tab">
                <div class="row mb-2">
                  <div class="col-md-6">
                    <h6 class="m-0">
                      <a v-b-toggle.accordion-5
                         class="text-dark"
                         href="javascript: void(0);">
                        Vale(s) Pedágio(s)
                      </a>
                    </h6>
                  </div>
                  <div class="col-md-6 text-end">
                    <b-button variant="outline-success" class="mx-2" @click="novoVPdg" :disabled="updating" v-if="movMdfeFiscalData.id > 0">
                      <i class="bx bx-plus font-size-16 align-middle me-2"></i>
                      Novo Vale Pedágio
                    </b-button>
                  </div>
                </div>
              </b-card-header>
              <b-collapse id="accordion-5" visible accordion="my-accordion-5" role="tabpanel">
                <b-card-body>
                  <div class="row mb-4">
                    <div class="table-responsive">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col">CNPJ Fornecedor</th>
                          <th scope="col">CNPJ Pagamento</th>
                          <th scope="col">CPF Pagamento</th>
                          <th scope="col">Núm.Compra</th>
                          <th scope="col" class="text-end">Valor Vale</th>
                          <th scope="col" class="text-end">Ações</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="data in movMdfeFiscalVPdgs" :key="data.id">
                          <td>
                            <h5 class="font-size-14 text-truncate" @click="editarUfPer(data)">
                              <span class="text-dark">
                                {{ data.id }}
                              </span>
                            </h5>
                          </td>
                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span class="text-dark">
                                {{ data.cnpjfor }}
                              </span>
                            </h5>
                          </td>
                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span class="text-dark">
                                {{ data.cnpjpg }}
                              </span>
                            </h5>
                          </td>
                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span class="text-dark">
                                {{ data.cpfpg }}
                              </span>
                            </h5>
                          </td>
                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span class="text-dark">
                                {{ data.ncompra }}
                              </span>
                            </h5>
                          </td>
                          <td class="text-end">
                            <h5 class="font-size-14 text-truncate">
                              <span class="text-dark">
                                {{ data.vvale }}
                              </span>
                            </h5>
                          </td>

                          <td class="text-end">
                            <div class="button-items">
                              <b-button variant="outline-warning" @click="editarVpdg(data)">
                                <i class="mdi mdi-pencil d-block font-size-16"></i>
                              </b-button>
                              <b-button variant="outline-danger" @click="deletarVPdg(data.id)">
                                <i class="mdi mdi-trash-can d-block font-size-16"></i>
                              </b-button>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </b-card-body>
              </b-collapse>
            </div>
          </div>

        </div>




        <div class="row">
          <div class="card col-md-12">
            <div class="card-body">
              <b-card-header header-tag="header" role="tab">
                <div class="row mb-2">
                  <div class="col-md-6">
                    <h6 class="m-0">
                      <a v-b-toggle.accordion-7
                         class="text-dark"
                         href="javascript: void(0);">
                        Veículo(s)
                      </a>
                    </h6>
                  </div>
                  <div class="col-md-6 text-end">
                    <b-button variant="outline-success" class="mx-2" @click="novoVeic" :disabled="updating" v-if="movMdfeFiscalData.id > 0">
                      <i class="bx bx-plus font-size-16 align-middle me-2"></i>
                      Novo Veículo
                    </b-button>
                  </div>
                </div>

              </b-card-header>
              <b-collapse id="accordion-7" visible accordion="my-accordion-7" role="tabpanel">
                <b-card-body>
                  <div class="row mb-4">
                    <div class="table-responsive">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col">TIPO</th>
                          <th scope="col">Código</th>
                          <th scope="col">Placa</th>
                          <th scope="col">Estado</th>
                          <th scope="col" class="text-end">Tara</th>
                          <th scope="col" class="text-end">Capacidade</th>
                          <th scope="col" class="text-end">Ações</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="data in movMdfeFiscalVeics" :key="data.id">
                          <td>
                            <h5 class="font-size-14 text-truncate" @click="editarVeic(data)">
                              <span class="text-dark">
                                {{ data.id }}
                              </span>
                            </h5>
                          </td>
                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span>
                                {{ data.tipo }}
                              </span>
                            </h5>
                          </td>
                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span>
                                {{ data.codigo }}
                              </span>
                            </h5>
                          </td>
                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span>
                                {{ data.placa }}
                              </span>
                            </h5>
                          </td>
                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span>
                                {{ data.estado }}
                              </span>
                            </h5>
                          </td>
                          <td class="text-end">
                            <h5 class="font-size-14 text-truncate">
                              <span>
                                {{ data.tara }}
                              </span>
                            </h5>
                          </td>
                          <td class="text-end">
                            <h5 class="font-size-14 text-truncate">
                              <span>
                                {{ data.capkg }}
                              </span>
                            </h5>
                          </td>

                          <td class="text-end">
                            <div class="button-items">
                              <b-button variant="outline-warning" @click="editarVeic(data)">
                                <i class="mdi mdi-pencil d-block font-size-16"></i>
                              </b-button>
                              <b-button variant="outline-danger" @click="deletarVeic(data.id)">
                                <i class="mdi mdi-trash-can d-block font-size-16"></i>
                              </b-button>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </b-card-body>
              </b-collapse>
            </div>
          </div>

        </div>


        <div class="row">
          <div class="card col-md-6">
            <div class="card-body">
              <b-card-header header-tag="header" role="tab">
                <div class="row mb-2">
                  <div class="col-md-6">
                    <h6 class="m-0">
                      <a v-b-toggle.accordion-8
                         class="text-dark"
                         href="javascript: void(0);">
                        Lacre(s)
                      </a>
                    </h6>
                  </div>
                  <div class="col-md-6 text-end">
                    <b-button variant="outline-success" class="mx-2" @click="novoLaRod" :disabled="updating" v-if="movMdfeFiscalData.id > 0">
                      <i class="bx bx-plus font-size-16 align-middle me-2"></i>
                      Novo Lacre
                    </b-button>
                  </div>
                </div>
              </b-card-header>
              <b-collapse id="accordion-8" visible accordion="my-accordion-8" role="tabpanel">
                <b-card-body>
                  <div class="row mb-4">
                    <div class="table-responsive">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col">Tipo</th>
                          <th scope="col">Lacre</th>
                          <th scope="col" class="text-end">Ações</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="data in movMdfeFiscalLaRods" :key="data.id">
                          <td>
                            <h5 class="font-size-14 text-truncate" @click="editarLaRod(data)">
                              <span class="text-dark">
                                {{ data.id }}
                              </span>
                            </h5>
                          </td>
                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span>
                                {{ data.tipo }}
                              </span>
                            </h5>
                          </td>
                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span>
                                {{ data.lacre }}
                              </span>
                            </h5>
                          </td>


                          <td class="text-end">
                            <div class="button-items">
                              <b-button variant="outline-warning" @click="editarLaRod(data)">
                                <i class="mdi mdi-pencil d-block font-size-16"></i>
                              </b-button>
                              <b-button variant="outline-danger" @click="deletarLaRod(data.id)">
                                <i class="mdi mdi-trash-can d-block font-size-16"></i>
                              </b-button>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </b-card-body>
              </b-collapse>
            </div>
          </div>




        </div>


        <div class="row">
          <div class="card col-md-6">
            <div class="card-body">
              <b-card-header header-tag="header" role="tab">
                <div class="row mb-2">
                  <div class="col-md-6">
                    <h6 class="m-0">
                      <a v-b-toggle.accordion-11
                         class="text-dark"
                         href="javascript: void(0);">
                        Seguro(s)
                      </a>
                    </h6>
                  </div>
                  <div class="col-md-6 text-end">
                    <b-button variant="outline-success" class="mx-2" @click="novoSeg" :disabled="updating" v-if="movMdfeFiscalData.id > 0">
                      <i class="bx bx-plus font-size-16 align-middle me-2"></i>
                      Novo Seguro
                    </b-button>
                  </div>
                </div>
              </b-card-header>
              <b-collapse id="accordion-11" visible accordion="my-accordion-11" role="tabpanel">
                <b-card-body>
                  <div class="row mb-4">
                    <div class="table-responsive">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col">Responsável</th>
                          <th scope="col">Seguradora</th>
                          <th scope="col">CNPJ</th>
                          <th scope="col" class="text-end">Ações</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="data in movMdfeFiscalSegs" :key="data.id">
                          <td>
                            <h5 class="font-size-14 text-truncate" @click="editarSeg(data)">
                              <span class="text-dark">
                                {{ data.id }}
                              </span>
                            </h5>
                          </td>
                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span>
                                {{ data.respseg }}
                              </span>
                            </h5>
                          </td>
                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span>
                                {{ data.xseg }}
                              </span>
                            </h5>
                          </td>
                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span>
                                {{ data.cnpjseg }}
                              </span>
                            </h5>
                          </td>


                          <td class="text-end">
                            <div class="button-items">
                              <b-button variant="outline-warning" @click="editarSeg(data)">
                                <i class="mdi mdi-pencil d-block font-size-16"></i>
                              </b-button>
                              <b-button variant="outline-danger" @click="deletarSeg(data.id)">
                                <i class="mdi mdi-trash-can d-block font-size-16"></i>
                              </b-button>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </b-card-body>
              </b-collapse>
            </div>
          </div>


          <div class="card col-md-6">
            <div class="card-body">
              <b-card-header header-tag="header" role="tab">
                <div class="row mb-2">
                  <div class="col-md-6">
                    <h6 class="m-0">
                      <a v-b-toggle.accordion-12
                         class="text-dark"
                         href="javascript: void(0);">
                        Autorizado(s) Download
                      </a>
                    </h6>
                  </div>
                  <div class="col-md-6 text-end">
                    <b-button variant="outline-success" class="mx-2" @click="novoAutD" :disabled="updating" v-if="movMdfeFiscalData.id > 0">
                      <i class="bx bx-plus font-size-16 align-middle me-2"></i>
                      Novo Autorizado
                    </b-button>
                  </div>
                </div>
              </b-card-header>
              <b-collapse id="accordion-12" visible accordion="my-accordion-12" role="tabpanel">
                <b-card-body>
                  <div class="row mb-4">
                    <div class="table-responsive">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col">CNPJ</th>
                          <th scope="col" class="text-end">Ações</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="data in movMdfeFiscalAutDs" :key="data.id">
                          <td>
                            <h5 class="font-size-14 text-truncate" @click="editarAutD(data)">
                              <span class="text-dark">
                                {{ data.id }}
                              </span>
                            </h5>
                          </td>
                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span class="text-dark">
                                {{ data.cnpj }}
                              </span>
                            </h5>
                          </td>

                          <td class="text-end">
                            <div class="button-items">
                              <b-button variant="outline-warning" @click="editarAutD(data)">
                                <i class="mdi mdi-pencil d-block font-size-16"></i>
                              </b-button>
                              <b-button variant="outline-danger" @click="deletarAutD(data.id)">
                                <i class="mdi mdi-trash-can d-block font-size-16"></i>
                              </b-button>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </b-card-body>
              </b-collapse>
            </div>
          </div>

        </div>



        <div class="row">
          <div class="card col-md-6">
            <div class="card-body">
              <b-card-header header-tag="header" role="tab">
                <div class="row mb-2">
                  <div class="col-md-6">
                    <h6 class="m-0">
                      <a v-b-toggle.accordion-13
                         class="text-dark"
                         href="javascript: void(0);">
                        Produto(s) Predominante(s)
                      </a>
                    </h6>
                  </div>
                  <div class="col-md-6 text-end">
                    <b-button variant="outline-success" class="mx-2" @click="novoProd" :disabled="updating" v-if="movMdfeFiscalData.id > 0">
                      <i class="bx bx-plus font-size-16 align-middle me-2"></i>
                      Novo Produto
                    </b-button>
                  </div>
                </div>
              </b-card-header>
              <b-collapse id="accordion-13" visible accordion="my-accordion-13" role="tabpanel">
                <b-card-body>
                  <div class="row mb-4">
                    <div class="table-responsive">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col">Produto</th>
                          <th scope="col">Cód.Barras</th>
                          <th scope="col">CEP Carregamento</th>
                          <th scope="col">CEP Descarregamento</th>
                          <th scope="col" class="text-end">Ações</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="data in movMdfeFiscalProds" :key="data.id">
                          <td>
                            <h5 class="font-size-14 text-truncate" @click="editarProd(data)">
                              <span class="text-dark">
                                {{ data.id }}
                              </span>
                            </h5>
                          </td>
                          <td style="max-width: 150px" class="text-wrap">
                            <h5 class="font-size-14 text-truncate">
                              <span>
                                {{ data.xprod }}
                              </span>
                            </h5>
                          </td>
                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span>
                                {{ data.cean }}
                              </span>
                            </h5>
                          </td>
                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span>
                                {{ data.locgcep }}
                              </span>
                            </h5>
                          </td>
                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span>
                                {{ data.lodcgcep }}
                              </span>
                            </h5>
                          </td>


                          <td class="text-end">
                            <div class="button-items">
                              <b-button variant="outline-warning" @click="editarProd(data)">
                                <i class="mdi mdi-pencil d-block font-size-16"></i>
                              </b-button>
                              <b-button variant="outline-danger" @click="deletarProd(data.id)">
                                <i class="mdi mdi-trash-can d-block font-size-16"></i>
                              </b-button>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </b-card-body>
              </b-collapse>
            </div>
          </div>


          <div class="card col-md-6">
            <div class="card-body">
              <b-card-header header-tag="header" role="tab">
                <div class="row mb-2">
                  <div class="col-md-6">
                    <h6 class="m-0">
                      <a v-b-toggle.accordion-14
                         class="text-dark"
                         href="javascript: void(0);">
                        Pagamento(s)
                      </a>
                    </h6>
                  </div>
                  <div class="col-md-6 text-end">
                    <b-button variant="outline-success" class="mx-2" @click="novoPag" :disabled="updating" v-if="movMdfeFiscalData.id > 0">
                      <i class="bx bx-plus font-size-16 align-middle me-2"></i>
                      Novo Pagamento
                    </b-button>
                  </div>
                </div>
              </b-card-header>
              <b-collapse id="accordion-14" visible accordion="my-accordion-14" role="tabpanel">
                <b-card-body>
                  <div class="row mb-4">
                    <div class="table-responsive">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col">Nome</th>
                          <th scope="col">CNPJ</th>
                          <th scope="col" class="text-end">Valor</th>
                          <th scope="col" class="text-end">Ações</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="data in movMdfeFiscalPags" :key="data.id">
                          <td>
                            <h5 class="font-size-14 text-truncate" @click="editarPag(data)">
                              <span class="text-dark">
                                {{ data.id }}
                              </span>
                            </h5>
                          </td>
                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span class="text-dark">
                                {{ data.nome }}
                              </span>
                            </h5>
                          </td>
                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span class="text-dark">
                                {{ data.cnpj }}
                              </span>
                            </h5>
                          </td>
                          <td class="text-end">
                            <h5 class="font-size-14 text-truncate">
                              <span class="text-dark">
                                {{ data.valor }}
                              </span>
                            </h5>
                          </td>

                          <td class="text-end">
                            <div class="button-items">
                              <b-button variant="outline-warning" @click="editarPag(data)">
                                <i class="mdi mdi-pencil d-block font-size-16"></i>
                              </b-button>
                              <b-button variant="outline-danger" @click="deletarPag(data.id)">
                                <i class="mdi mdi-trash-can d-block font-size-16"></i>
                              </b-button>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </b-card-body>
              </b-collapse>
            </div>
          </div>

        </div>



      </form>
    </div>



    <b-modal size="lg"
             :title="movMdfeFiscalUfPer.id > 0 ? `Editar Estado de Percurso (${ movMdfeFiscalUfPer.id })` : 'Criando novo Estado de Percurso'"
             v-model="showModalUfPer" centered hide-footer>
      <div class="row">
        <div class="col-sm-12">
          <div class="mb-3">
            <label for="estado">Estado</label>
            <select
                id="estado"
                v-model="movMdfeFiscalUfPer.estado"
                class="form-control"
                :class="{'is-invalid': submittedUfPer && !movMdfeFiscalUfPer.estado}">
              <option value="AC">Acre</option>
              <option value="AL">Alagoas</option>
              <option value="AP">Amapá</option>
              <option value="AM">Amazonas</option>
              <option value="BA">Bahia</option>
              <option value="CE">Ceará</option>
              <option value="ES">Espírito Santo</option>
              <option value="GO">Goiás</option>
              <option value="MA">Maranhão</option>
              <option value="MT">Mato Grosso</option>
              <option value="MS">Mato Grosso do Sul</option>
              <option value="MG">Minas Gerais</option>
              <option value="PA">Pará</option>
              <option value="PB">Paraíba</option>
              <option value="PR">Paraná</option>
              <option value="PE">Pernambuco</option>
              <option value="PI">Piauí</option>
              <option value="RJ">Rio de Janeiro</option>
              <option value="RN">Rio Grande do Norte</option>
              <option value="RS">Rio Grande do Sul</option>
              <option value="RO">Rondônia</option>
              <option value="RR">Roraima</option>
              <option value="SC">Santa Catarina</option>
              <option value="SP">São Paulo</option>
              <option value="SE">Sergipe</option>
              <option value="TO">Tocantins</option>
              <option value="DF">Distrito Federal</option>
            </select>
            <div v-if="submittedUfPer && !movMdfeFiscalUfPer.estado" class="invalid-feedback">
              <span>Campo estado obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>

      </div>
      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalUfPer = false">
          <i class="bx bx-sync font-size-16 align-middle me-2"></i>
          Fechar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confUfPer">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>


    <b-modal size="md"
             :title="movMdfeFiscalMunCg.id > 0 ? `Editar Município de Carregamento (${ movMdfeFiscalMunCg.id })` : 'Criando novo Município de Carregamento'"
             v-model="showModalMunCg" centered hide-footer>
      <div class="row">

        <div class="col-md-12">

          <div class="mb-3">
            <span>Pesquisar Municípios</span>

            <multiselect id="inputCidade"
                         @search-change="pesqCidade"
                         v-model="movMdfeFiscalMunCg.cmun"
                         placeholder="Pesquisar cidade"
                         :options="dtListPesqCidade"
                         :searchable="true"
                         label="descricao"
                         track-by="descricao"
                         :style="submittedMunCg && !movMdfeFiscalMunCg.cmun ? 'border: 1px solid #f86c6b !important;' : ''"
                         value-prop="codigo">
              <template #option="slotProps">
                <div class="row">
                  <div>
                    <span class="text-info">
                      {{ slotProps.option.codigo }}
                    </span>
                    <span class="mx-4" >
                      {{ slotProps.option.estado }}
                    </span>
                    <span class="mx-4" >
                      {{ slotProps.option.descricao }}
                    </span>
                  </div>
                </div>
              </template>
            </multiselect>
            <div v-if="submittedMunCg && !movMdfeFiscalMunCg.cmun">
              <span class="text-danger font-size-11">Campo Município obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>

      </div>
      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalMunCg = false">
          <i class="bx bx-sync font-size-16 align-middle me-2"></i>
          Fechar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confMunCg">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>



    <b-modal size="lg"
             :title="movMdfeFiscalCiot.id > 0 ? `Editar CIOT (${ movMdfeFiscalCiot.id })` : 'Criando novo CIOT'"
             v-model="showModalCiot" centered hide-footer>
      <div class="row">
        <div class="col-sm-4">
          <div class="mb-3">
            <label for="ciot">CIOT</label>
            <input id="ciot"
                   v-model="movMdfeFiscalCiot.ciot"
                   type="text"
                   class="form-control"
                   :class="{'is-invalid': submittedCiot && !movMdfeFiscalCiot.ciot}"
                   placeholder="CIOT" />
            <div v-if="submittedCiot && !movMdfeFiscalCiot.ciot" class="invalid-feedback">
              <span>Campo CIOT obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="mb-3">
            <label for="cpf">Número do CPF responsável pela geração do CIOT</label>
            <input id="cpf"
                   v-model="movMdfeFiscalCiot.cpf"
                   type="text"
                   class="form-control"
                   placeholder="CPF" />
          </div>
        </div>
        <div class="col-sm-4">
          <div class="mb-3">
            <label for="cnpj">Número do CNPJ responsável pela geração do CIOT</label>
            <input id="cnpj"
                   v-model="movMdfeFiscalCiot.cnpj"
                   type="text"
                   class="form-control"
                   placeholder="CNPJ" />
          </div>
        </div>
      </div>
      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalCiot = false">
          <i class="bx bx-sync font-size-16 align-middle me-2"></i>
          Fechar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confCiot">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>


    <b-modal size="lg"
             :title="movMdfeFiscalVPdg.id > 0 ? `Editar Vale Pedágio (${ movMdfeFiscalVPdg.id })` : 'Criando novo Vale Pedágio'"
             v-model="showModalVPdg" centered hide-footer>
      <div class="row">
        <div class="col-sm-4">
          <div class="mb-3">
            <label for="cnpjfor">CNPJ Fornecedor</label>
            <input id="cnpjfor"
                   v-model="movMdfeFiscalVPdg.cnpjfor"
                   type="text"
                   class="form-control"
                   :class="{'is-invalid': submittedVPdg && !movMdfeFiscalVPdg.cnpjfor}"
                   placeholder="CNPJ Fornecedor" />
            <div v-if="submittedVPdg && !movMdfeFiscalVPdg.cnpjfor" class="invalid-feedback">
              <span>Campo CNPJ Fornecedor obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="mb-3">
            <label for="cnpjpg">CNPJ Pagamento</label>
            <input id="cnpjpg"
                   v-model="movMdfeFiscalVPdg.cnpjpg"
                   type="text"
                   class="form-control"
                   placeholder="CNPJ Pagamento" />
          </div>
        </div>
        <div class="col-sm-4">
          <div class="mb-3">
            <label for="cpfpg">CPF Pagamento</label>
            <input id="cpfpg"
                   v-model="movMdfeFiscalVPdg.cpfpg"
                   type="text"
                   class="form-control"
                   placeholder="CPF Pagamento" />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-6">
          <div class="mb-3">
            <label for="ncompra">Número Compra</label>
            <input id="ncompra"
                   v-model="movMdfeFiscalVPdg.ncompra"
                   type="text"
                   class="form-control"
                   placeholder="Número Compra" />
          </div>
        </div>
        <div class="col-sm-6">
          <div class="mb-3">
            <label for="vvale">Valor Vale</label>
            <input id="vvale"
                   v-model="movMdfeFiscalVPdg.vvale"
                   type="number"
                   class="form-control"
                   placeholder="Valor Vale" />
          </div>
        </div>
      </div>

      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalVPdg = false">
          <i class="bx bx-sync font-size-16 align-middle me-2"></i>
          Fechar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confVPdg">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>



    <b-modal size="sm"
             :title="movMdfeFiscalCont.id > 0 ? `Editar Contratante (${ movMdfeFiscalCont.id })` : 'Criando novo Contratante'"
             v-model="showModalCont" centered hide-footer>
      <div class="row">
        <div class="col-sm-12">
          <div class="mb-3">
            <label for="cnpj">CNPJ</label>
            <input id="cnpj"
                   v-model="movMdfeFiscalCont.cnpj"
                   type="text"
                   class="form-control"
                   :class="{'is-invalid': submittedCont && !movMdfeFiscalCont.cnpj}"
                   placeholder="CNPJ" />
            <div v-if="submittedCont && !movMdfeFiscalCont.cnpj" class="invalid-feedback">
              <span>Campo CNPJ obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>
      </div>

      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalCont = false">
          <i class="bx bx-sync font-size-16 align-middle me-2"></i>
          Fechar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confCont">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>



    <b-modal size="lg"
             :title="movMdfeFiscalVeic.id > 0 ? `Editar Veículo (${ movMdfeFiscalVeic.id })` : 'Criando novo Veículo'"
             v-model="showModalVeic" centered hide-footer>

      <div class="row mb-2">

        <div class="col-sm-3">
          <div class="mb-3">
            <label for="tipo">Tipo</label>
            <select
                id="tipo"
                v-model="movMdfeFiscalVeic.tipo"
                class="form-control"
                :class="{'is-invalid': submittedVeic && !movMdfeFiscalVeic.tipo}">
              <option value="TR">Tração</option>
              <option value="RB">Reboque</option>
            </select>
            <div v-if="submittedVeic && !movMdfeFiscalVeic.tipo" class="invalid-feedback">
              <span>Campo tipo obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>

        <div class="col-sm-3">
          <div class="mb-3">
            <label for="estado">Estado</label>
            <select
                id="estado"
                v-model="movMdfeFiscalVeic.estado"
                class="form-control">
              <option value="AC">Acre</option>
              <option value="AL">Alagoas</option>
              <option value="AP">Amapá</option>
              <option value="AM">Amazonas</option>
              <option value="BA">Bahia</option>
              <option value="CE">Ceará</option>
              <option value="ES">Espírito Santo</option>
              <option value="GO">Goiás</option>
              <option value="MA">Maranhão</option>
              <option value="MT">Mato Grosso</option>
              <option value="MS">Mato Grosso do Sul</option>
              <option value="MG">Minas Gerais</option>
              <option value="PA">Pará</option>
              <option value="PB">Paraíba</option>
              <option value="PR">Paraná</option>
              <option value="PE">Pernambuco</option>
              <option value="PI">Piauí</option>
              <option value="RJ">Rio de Janeiro</option>
              <option value="RN">Rio Grande do Norte</option>
              <option value="RS">Rio Grande do Sul</option>
              <option value="RO">Rondônia</option>
              <option value="RR">Roraima</option>
              <option value="SC">Santa Catarina</option>
              <option value="SP">São Paulo</option>
              <option value="SE">Sergipe</option>
              <option value="TO">Tocantins</option>
              <option value="DF">Distrito Federal</option>
            </select>
          </div>
        </div>

        <div class="col-sm-3">
          <div class="mb-3">
            <label for="cint">Código Interno</label>
            <input id="cint"
                   v-model="movMdfeFiscalVeic.cint"
                   type="text"
                   class="form-control"
                   placeholder="Código Interno" />
          </div>
        </div>

        <div class="col-sm-3">
          <div class="mb-3">
            <label for="placa">Placa</label>
            <input id="placa"
                   v-model="movMdfeFiscalVeic.placa"
                   type="text"
                   class="form-control"
                   :class="{'is-invalid': submittedVeic && !movMdfeFiscalVeic.placa}"
                   placeholder="Placa" />
            <div v-if="submittedVeic && !movMdfeFiscalVeic.placa" class="invalid-feedback">
              <span>Campo Placa obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>


      </div>

      <div class="row mb-2">

        <div class="col-sm-3">
          <div class="mb-3">
            <label for="tara">Tara</label>
            <input id="tara"
                   v-model="movMdfeFiscalVeic.tara"
                   type="number"
                   class="form-control"
                   placeholder="Tara" />
          </div>
        </div>

        <div class="col-sm-3">
          <div class="mb-3">
            <label for="capkg">Capacidade KG</label>
            <input id="capkg"
                   v-model="movMdfeFiscalVeic.capkg"
                   type="number"
                   class="form-control"
                   placeholder="Capacidade KG" />
          </div>
        </div>

        <div class="col-sm-3">
          <div class="mb-3">
            <label for="tprod">Tipo de Rodado</label>
            <select
                id="tprod"
                v-model="movMdfeFiscalVeic.tprod"
                class="form-control">
              <option value="01">Truck</option>
              <option value="02">Toco</option>
              <option value="03">Cavalo-Mecânico</option>
              <option value="04">Van</option>
              <option value="05">Utilitário</option>
              <option value="06">Outros</option>
            </select>
          </div>
        </div>

        <div class="col-sm-3">
          <div class="mb-3">
            <label for="tpcar">Tipo de Carroceria</label>
            <select
                id="tpcar"
                v-model="movMdfeFiscalVeic.tpcar"
                class="form-control">
              <option value="00">Não Aplicável</option>
              <option value="01">Aberta</option>
              <option value="02">Fechada</option>
              <option value="03">Granelera</option>
              <option value="04">Porta Container</option>
              <option value="05">Sider</option>
            </select>
          </div>
        </div>

      </div>

      <div v-if="movMdfeFiscalVeic.tipo === 'TR'">
        <hr>
        <div class="row mb-2 text-center">
          <h6 class="m-0">
            Informações do Condutor
          </h6>
        </div>
        <div class="row mb-2">
          <div class="col-sm-6">
            <div class="mb-3">
              <label for="condutnome">Nome</label>
              <input id="condutnome"
                     v-model="movMdfeFiscalVeic.condutnome"
                     type="text"
                     class="form-control"
                     placeholder="Nome Condutor" />
            </div>
          </div>
          <div class="col-sm-6">
            <div class="mb-3">
              <label for="condutcpf">CPF</label>
              <input id="condutcpf"
                     v-model="movMdfeFiscalVeic.condutcpf"
                     type="text"
                     class="form-control"
                     placeholder="CPF Condutor" />
            </div>
          </div>
        </div>
      </div>


      <div v-if="movMdfeFiscalVeic.tipo === 'RB'">
        <hr>
        <div class="row mb-2 text-center">
          <h6 class="m-0">
            Informações do Proprietário
          </h6>
        </div>
        <div class="row mb-2">
          <div class="col-sm-6">
            <div class="mb-3">
              <label for="propnome">Nome</label>
              <input id="propnome"
                     v-model="movMdfeFiscalVeic.propnome"
                     type="text"
                     class="form-control"
                     placeholder="Nome Proprietário" />
            </div>
          </div>
          <div class="col-sm-6">
            <div class="mb-3">
              <label for="propcnpj">CPF/CNPJ</label>
              <input id="propcnpj"
                     v-model="movMdfeFiscalVeic.propcnpj"
                     type="text"
                     class="form-control"
                     placeholder="CPF/CNPJ Proprietário" />
            </div>
          </div>
          <div class="col-sm-3">
            <div class="mb-3">
              <label for="proprntrc">RNTRC</label>
              <input id="proprntrc"
                     v-model="movMdfeFiscalVeic.proprntrc"
                     type="text"
                     class="form-control"
                     placeholder="RNTRC Proprietário" />
            </div>
          </div>
          <div class="col-sm-3">
            <div class="mb-3">
              <label for="propie">Inscrição Estadual</label>
              <input id="propie"
                     v-model="movMdfeFiscalVeic.propie"
                     type="text"
                     class="form-control"
                     placeholder="Inscrição Estadual Proprietário" />
            </div>
          </div>
          <div class="col-sm-3">
            <div class="mb-3">
              <label for="propestado">Estado</label>
              <select
                  id="propestado"
                  v-model="movMdfeFiscalVeic.propestado"
                  class="form-control">
                <option value="AC">Acre</option>
                <option value="AL">Alagoas</option>
                <option value="AP">Amapá</option>
                <option value="AM">Amazonas</option>
                <option value="BA">Bahia</option>
                <option value="CE">Ceará</option>
                <option value="ES">Espírito Santo</option>
                <option value="GO">Goiás</option>
                <option value="MA">Maranhão</option>
                <option value="MT">Mato Grosso</option>
                <option value="MS">Mato Grosso do Sul</option>
                <option value="MG">Minas Gerais</option>
                <option value="PA">Pará</option>
                <option value="PB">Paraíba</option>
                <option value="PR">Paraná</option>
                <option value="PE">Pernambuco</option>
                <option value="PI">Piauí</option>
                <option value="RJ">Rio de Janeiro</option>
                <option value="RN">Rio Grande do Norte</option>
                <option value="RS">Rio Grande do Sul</option>
                <option value="RO">Rondônia</option>
                <option value="RR">Roraima</option>
                <option value="SC">Santa Catarina</option>
                <option value="SP">São Paulo</option>
                <option value="SE">Sergipe</option>
                <option value="TO">Tocantins</option>
                <option value="DF">Distrito Federal</option>
              </select>
            </div>
          </div>
          <div class="col-sm-3">
            <div class="mb-3">
              <label for="proptp">Tipo</label>
              <select
                  id="proptp"
                  v-model="movMdfeFiscalVeic.proptp"
                  class="form-control">
                <option value="1">Default</option>

              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalVeic = false">
          <i class="bx bx-sync font-size-16 align-middle me-2"></i>
          Fechar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confVeic">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>


    <b-modal size="md"
             :title="movMdfeFiscalLaRod.id > 0 ? `Editar Lacre Rodoviário (${ movMdfeFiscalLaRod.id })` : 'Criando novo Lacre Rodoviário'"
             v-model="showModalLaRod" centered hide-footer>
      <div class="row">

        <div class="col-sm-3">
          <div class="mb-3">
            <label for="tipo">Tipo</label>
            <select
                id="tipo"
                v-model="movMdfeFiscalLaRod.tipo"
                class="form-control"
                :class="{'is-invalid': submittedDoc && !movMdfeFiscalLaRod.tipo}">
              <option value="CO">Comum</option>
              <option value="RD">Rodoviário</option>
            </select>
            <div v-if="submittedDoc && !movMdfeFiscalLaRod.tipo" class="invalid-feedback">
              <span>Campo tipo obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>

        <div class="col-sm-9">
          <div class="mb-3">
            <label for="lacre">Lacre</label>
            <input id="lacre"
                   v-model="movMdfeFiscalLaRod.lacre"
                   type="text"
                   class="form-control"
                   :class="{'is-invalid': submittedLaRod && !movMdfeFiscalLaRod.lacre}"
                   placeholder="Lacre" />
            <div v-if="submittedLaRod && !movMdfeFiscalLaRod.lacre" class="invalid-feedback">
              <span>Campo Lacre obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>

      </div>

      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalLaRod = false">
          <i class="bx bx-sync font-size-16 align-middle me-2"></i>
          Fechar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confLaRod">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>



    <b-modal size="lg"
             :title="movMdfeFiscalMunDcg.id > 0 ? `Editar Município Descarga (${ movMdfeFiscalMunDcg.id })` : 'Criando novo Município Descarga'"
             v-model="showModalMunDcg" centered hide-footer>
      <div class="row">

        <div class="col-md-9">
          <div class="mb-3">
            <span>Pesquisar Municípios</span>
            <multiselect id="inputCidade"
                         @search-change="pesqCidade"
                         v-model="movMdfeFiscalMunDcg.cmun"
                         placeholder="Pesquisar cidade"
                         :options="dtListPesqCidade"
                         :searchable="true"
                         label="descricao"
                         track-by="descricao"
                         :style="submittedMunDcg && !movMdfeFiscalMunDcg.cmun ? 'border: 1px solid #f86c6b !important;' : ''"
                         value-prop="codigo">
              <template #option="slotProps">
                <div class="row">
                  <div>
                    <span class="text-info">
                      {{ slotProps.option.codigo }}
                    </span>
                    <span class="mx-4" >
                      {{ slotProps.option.estado }}
                    </span>
                    <span class="mx-4" >
                      {{ slotProps.option.descricao }}
                    </span>
                  </div>
                </div>
              </template>
            </multiselect>
            <div v-if="submittedMunDcg && !movMdfeFiscalMunDcg.cmun">
              <span class="text-danger font-size-11">Campo Município obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>

        <div class="col-sm-3">
          <div class="mb-3">
            <label for="nitem">Número Item</label>
            <input id="nitem"
                   v-model="movMdfeFiscalMunDcg.nitem"
                   type="number"
                   class="form-control"
                   :class="{'is-invalid': submittedMunDcg && !movMdfeFiscalMunDcg.nitem}"
                   placeholder="Número Item" />
            <div v-if="submittedMunDcg && !movMdfeFiscalMunDcg.nitem" class="invalid-feedback">
              <span>Campo Número Item obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>


      </div>

      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalMunDcg = false">
          <i class="bx bx-sync font-size-16 align-middle me-2"></i>
          Fechar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confMunDcg">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>



    <b-modal size="lg"
             :title="movMdfeFiscalDoc.id > 0 ? `Editar Documento (${ movMdfeFiscalDoc.id })` : 'Criando novo Documento'"
             v-model="showModalDoc" centered hide-footer>

      <div class="row mb-2">

        <div class="col-sm-3">
          <div class="mb-3">
            <label for="tipo">Tipo</label>
            <select
                id="tipo"
                v-model="movMdfeFiscalDoc.tipo"
                class="form-control"
                :class="{'is-invalid': submittedDoc && !movMdfeFiscalDoc.tipo}">
              <option value="CTE">CT-e</option>
              <option value="NFE">NF-e</option>
              <option value="MDFE">MDF-e</option>
            </select>
            <div v-if="submittedDoc && !movMdfeFiscalDoc.tipo" class="invalid-feedback">
              <span>Campo tipo obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>

<!--        <div class="col-sm-9">-->
<!--          <div class="mb-3">-->
<!--            <label for="chave">Chave</label>-->
<!--            <input id="chave"-->
<!--                   v-model="movMdfeFiscalDoc.chave"-->
<!--                   type="text"-->
<!--                   class="form-control"-->
<!--                   :class="{'is-invalid': submittedDoc && !movMdfeFiscalDoc.chave}"-->
<!--                   placeholder="Chave" />-->
<!--            <div v-if="submittedDoc && !movMdfeFiscalDoc.chave" class="invalid-feedback">-->
<!--              <span>Campo Chave obrigatório, favor preencher.</span>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->

        <div class="col-sm-9">

          <div class="mb-3">
            <span>Selecionar Movimento</span>

            <multiselect id="inputMovimento"
                         @search-change="pesqMovChave"
                         v-model="movMdfeFiscalDoc.chave"
                         placeholder="Pesquisar movimento"
                         :options="dtListPesqMov"
                         :searchable="true"
                         label="chave"
                         track-by="chave"
                         value-prop="chave">
              <template #option="slotProps">
                <div class="row">
                  <div>
                    <span class="text-info">
                      {{ slotProps.option.id }}
                    </span>
                    <span class="mx-4" >
                      {{ slotProps.option.codigo }}
                    </span>
                  </div>
                  <div class="mt-2 font-size-20">{{ slotProps.option.destnome }}</div>
                  <div class="mt-2 font-size-20">{{ slotProps.option.chave }}</div>
                  <div class="align-items-end text-end align-content-end">{{ slotProps.option.destcnpj }}</div>
                </div>
              </template>
            </multiselect>

          </div>

        </div>



        <div class="col-sm-6">
          <div class="mb-3">
            <label for="segcodbar">Segundo Cód.Barras</label>
            <input id="segcodbar"
                   v-model="movMdfeFiscalDoc.segcodbar"
                   type="text"
                   class="form-control"
                   placeholder="Segundo Cód.Barras" />
          </div>
        </div>
        <div class="col-sm-3">
          <div class="mb-3">
            <label for="indreent">Indicador Reentrega</label>
            <input id="indreent"
                   v-model="movMdfeFiscalDoc.indreent"
                   type="text"
                   class="form-control"
                   placeholder="Indicador Reentrega" />
          </div>
        </div>
        <div class="col-sm-3">
          <div class="mb-3">
            <label for="nitem">Número Item</label>
            <input id="nitem"
                   v-model="movMdfeFiscalDoc.nitem"
                   type="text"
                   class="form-control"
                   placeholder="Número Item" />
          </div>
        </div>
        <div class="col-sm-3">
          <div class="mb-3">
            <label for="tpuntransp">Tipo Unidade Transporte</label>
            <input id="tpuntransp"
                   v-model="movMdfeFiscalDoc.tpuntransp"
                   type="text"
                   class="form-control"
                   placeholder="Tipo Unidade Transporte" />
          </div>
        </div>
        <div class="col-sm-3">
          <div class="mb-3">
            <label for="iduntransp">ID Unidade Transporte</label>
            <input id="iduntransp"
                   v-model="movMdfeFiscalDoc.iduntransp"
                   type="text"
                   class="form-control"
                   placeholder="ID Unidade Transporte" />
          </div>
        </div>
        <div class="col-sm-6">
          <div class="mb-3">
            <label for="lacrtransp">Lacre(s) Unidade Transporte</label>
            <input id="lacrtransp"
                   v-model="movMdfeFiscalDoc.lacrtransp"
                   type="text"
                   class="form-control"
                   placeholder="Lacre(s) Unidade Transporte" />
          </div>
        </div>
        <div class="col-sm-3">
          <div class="mb-3">
            <label for="tpuncarga">Tipo Unidade Carga</label>
            <input id="tpuncarga"
                   v-model="movMdfeFiscalDoc.tpuncarga"
                   type="text"
                   class="form-control"
                   placeholder="Tipo Unidade Carga" />
          </div>
        </div>
        <div class="col-sm-3">
          <div class="mb-3">
            <label for="iduncarga">ID Unidade Carga</label>
            <input id="iduncarga"
                   v-model="movMdfeFiscalDoc.iduncarga"
                   type="text"
                   class="form-control"
                   placeholder="ID Unidade Carga" />
          </div>
        </div>
        <div class="col-sm-6">
          <div class="mb-3">
            <label for="lacrcarga">Lacre(s) Unidade Carga</label>
            <input id="lacrcarga"
                   v-model="movMdfeFiscalDoc.lacrcarga"
                   type="text"
                   class="form-control"
                   placeholder="Lacre(s) Unidade Carga" />
          </div>
        </div>

      </div>

      <div class="row mb-2">

        <div class="col-sm-6">
          <div class="mb-3">
            <label for="qtdrattransp">Qtd.Rateio Unidade Transporte</label>
            <input id="qtdrattransp"
                   v-model="movMdfeFiscalDoc.qtdrattransp"
                   type="number"
                   class="form-control"
                   placeholder="Qtd.Rateio Unidade Transporte" />
          </div>
        </div>
        <div class="col-sm-6">
          <div class="mb-3">
            <label for="qtdratcarga">Qtd.Rateio Unidade Carga</label>
            <input id="qtdratcarga"
                   v-model="movMdfeFiscalDoc.qtdratcarga"
                   type="number"
                   class="form-control"
                   placeholder="Qtd.Rateio Unidade Carga" />
          </div>
        </div>

      </div>

      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalDoc = false">
          <i class="bx bx-sync font-size-16 align-middle me-2"></i>
          Fechar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confDoc">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>


    <b-modal size="lg"
             :title="movMdfeFiscalSeg.id > 0 ? `Editar Seguro (${ movMdfeFiscalSeg.id })` : 'Criando novo Seguro'"
             v-model="showModalSeg" centered hide-footer>

      <div class="row mb-2">

        <div class="col-sm-3">
          <div class="mb-3">
            <label for="respseg">Responsável Seguro</label>
            <input id="respseg"
                   v-model="movMdfeFiscalSeg.respseg"
                   type="text"
                   class="form-control"
                   :class="{'is-invalid': submittedSeg && !movMdfeFiscalSeg.respseg}"
                   placeholder="Responsável Seguro" />
            <div v-if="submittedSeg && !movMdfeFiscalSeg.respseg" class="invalid-feedback">
              <span>Campo Responsável Seguro obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="mb-3">
            <label for="xseg">Nome Seguradora</label>
            <input id="xseg"
                   v-model="movMdfeFiscalSeg.xseg"
                   type="text"
                   class="form-control"
                   placeholder="Nome Seguradora" />
          </div>
        </div>
        <div class="col-sm-3">
          <div class="mb-3">
            <label for="cnpjseg">CNPJ Seguradora</label>
            <input id="cnpjseg"
                   v-model="movMdfeFiscalSeg.cnpjseg"
                   type="text"
                   class="form-control"
                   placeholder="CNPJ Seguradora" />
          </div>
        </div>
        <div class="col-sm-6">
          <div class="mb-3">
            <label for="napol">Número Apólice</label>
            <input id="napol"
                   v-model="movMdfeFiscalSeg.napol"
                   type="text"
                   class="form-control"
                   placeholder="Número Apólice" />
          </div>
        </div>
        <div class="col-sm-6">
          <div class="mb-3">
            <label for="naver">Número Averbações</label>
            <input id="naver"
                   v-model="movMdfeFiscalSeg.naver"
                   type="text"
                   class="form-control"
                   placeholder="Número Averbações" />
          </div>
        </div>
      </div>

      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalSeg = false">
          <i class="bx bx-sync font-size-16 align-middle me-2"></i>
          Fechar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confSeg">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>



    <b-modal size="md"
             :title="movMdfeFiscalAutD.id > 0 ? `Editar Autorizado Download (${ movMdfeFiscalAutD.id })` : 'Criando novo Autorizado Download'"
             v-model="showModalAutD" centered hide-footer>
      <div class="row mb-2">
        <div class="col-sm-12">
          <div class="mb-3">
            <label for="cnpj">CNPJ</label>
            <input id="cnpj"
                   v-model="movMdfeFiscalAutD.cnpj"
                   type="text"
                   class="form-control"
                   :class="{'is-invalid': submittedAutD && !movMdfeFiscalAutD.cnpj}"
                   placeholder="CNPJ" />
            <div v-if="submittedAutD && !movMdfeFiscalAutD.cnpj" class="invalid-feedback">
              <span>Campo CNPJ obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>
      </div>
      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalAutD = false">
          <i class="bx bx-sync font-size-16 align-middle me-2"></i>
          Fechar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confAutD">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>


    <b-modal size="lg"
             :title="movMdfeFiscalProd.id > 0 ? `Editar Produto Predominante (${ movMdfeFiscalProd.id })` : 'Criando novo Produto Predominante'"
             v-model="showModalProd" centered hide-footer>
      <div class="row mb-2">
        <div class="col-sm-3">
          <div class="mb-3">
            <label for="tpcarga">Tipo Carga</label>
            <input id="tpcarga"
                   v-model="movMdfeFiscalProd.tpcarga"
                   type="text"
                   class="form-control"
                   :class="{'is-invalid': submittedProd && !movMdfeFiscalProd.tpcarga}"
                   placeholder="Tipo Carga" />
            <div v-if="submittedProd && !movMdfeFiscalProd.tpcarga" class="invalid-feedback">
              <span>Campo Tipo Carga obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>
        <div class="col-sm-9">
          <div class="mb-3">
            <label for="xprod">Produto</label>
            <input id="xprod"
                   v-model="movMdfeFiscalProd.xprod"
                   type="text"
                   class="form-control"
                   :class="{'is-invalid': submittedProd && !movMdfeFiscalProd.xprod}"
                   placeholder="Produto" />
            <div v-if="submittedProd && !movMdfeFiscalProd.xprod" class="invalid-feedback">
              <span>Campo Produto obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="mb-3">
            <label for="cean">Código de Barras</label>
            <input id="cean"
                   v-model="movMdfeFiscalProd.cean"
                   type="text"
                   class="form-control"
                   placeholder="Código de Barras" />
          </div>
        </div>
        <div class="col-sm-6">
          <div class="mb-3">
            <label for="ncm">NCM</label>
            <input id="ncm"
                   v-model="movMdfeFiscalProd.ncm"
                   type="text"
                   class="form-control"
                   placeholder="NCM" />
          </div>
        </div>
      </div>

      <hr>
      <h6 class="m-0 text-center mb-2">
        Local Carregamento
      </h6>
      <div class="row mb-2">
        <div class="col-sm-4">
          <div class="mb-3">
            <label for="locgcep">CEP</label>
            <input id="locgcep"
                   v-model="movMdfeFiscalProd.locgcep"
                   type="text"
                   class="form-control"
                   placeholder="CEP" />
          </div>
        </div>
        <div class="col-sm-4">
          <div class="mb-3">
            <label for="locglat">Latitude</label>
            <input id="locglat"
                   v-model="movMdfeFiscalProd.locglat"
                   type="text"
                   class="form-control"
                   placeholder="Latitude" />
          </div>
        </div>
        <div class="col-sm-4">
          <div class="mb-3">
            <label for="locglong">Longitude</label>
            <input id="locglong"
                   v-model="movMdfeFiscalProd.locglong"
                   type="text"
                   class="form-control"
                   placeholder="Longitude" />
          </div>
        </div>
      </div>

      <hr>
      <h6 class="m-0 text-center mb-2">
        Local Descarregamento
      </h6>
      <div class="row mb-2">
        <div class="col-sm-4">
          <div class="mb-3">
            <label for="lodcgcep">CEP</label>
            <input id="lodcgcep"
                   v-model="movMdfeFiscalProd.lodcgcep"
                   type="text"
                   class="form-control"
                   placeholder="CEP" />
          </div>
        </div>
        <div class="col-sm-4">
          <div class="mb-3">
            <label for="lodcglat">Latitude</label>
            <input id="lodcglat"
                   v-model="movMdfeFiscalProd.lodcglat"
                   type="text"
                   class="form-control"
                   placeholder="Latitude" />
          </div>
        </div>
        <div class="col-sm-4">
          <div class="mb-3">
            <label for="lodcglong">Longitude</label>
            <input id="lodcglong"
                   v-model="movMdfeFiscalProd.lodcglong"
                   type="text"
                   class="form-control"
                   placeholder="Longitude" />
          </div>
        </div>
      </div>

      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalProd = false">
          <i class="bx bx-sync font-size-16 align-middle me-2"></i>
          Fechar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confProd">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>



    <b-modal size="lg"
             :title="movMdfeFiscalPag.id > 0 ? `Editar Pagamento (${ movMdfeFiscalPag.id })` : 'Criando novo Pagamento'"
             v-model="showModalPag" centered hide-footer>
      <div class="row mb-2">
        <div class="col-sm-6">
          <div class="mb-3">
            <label for="nome">Nome</label>
            <input id="nome"
                   v-model="movMdfeFiscalPag.nome"
                   type="text"
                   class="form-control"
                   :class="{'is-invalid': submittedPag && !movMdfeFiscalPag.nome}"
                   placeholder="Nome" />
            <div v-if="submittedPag && !movMdfeFiscalPag.nome" class="invalid-feedback">
              <span>Campo Nome obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="mb-3">
            <label for="cnpj">CNPJ / CPF</label>
            <input id="cnpj"
                   v-model="movMdfeFiscalPag.cnpj"
                   type="text"
                   class="form-control"
                   :class="{'is-invalid': submittedPag && !movMdfeFiscalPag.cnpj}"
                   placeholder="CNPJ" />
            <div v-if="submittedPag && !movMdfeFiscalPag.cnpj" class="invalid-feedback">
              <span>Campo CNPJ obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>
        <div class="col-sm-3">
          <div class="mb-3">
            <label for="vencimento">Vencimento</label>
            <input id="vencimento"
                   v-model="movMdfeFiscalPag.vencimento"
                   type="date"
                   class="form-control"
                   placeholder="Vencimento" />
          </div>
        </div>
        <div class="col-sm-3">
          <div class="mb-3">
            <label for="codbanco">Código Banco</label>
            <input id="codbanco"
                   v-model="movMdfeFiscalPag.codbanco"
                   type="text"
                   class="form-control"
                   placeholder="Código Banco" />
          </div>
        </div>
        <div class="col-sm-3">
          <div class="mb-3">
            <label for="codagencia">Código Agência</label>
            <input id="codagencia"
                   v-model="movMdfeFiscalPag.codagencia"
                   type="text"
                   class="form-control"
                   placeholder="Código Agência" />
          </div>
        </div>
        <div class="col-sm-3">
          <div class="mb-3">
            <label for="valor">Valor</label>
            <input id="valor"
                   v-model="movMdfeFiscalPag.valor"
                   type="number"
                   class="form-control"
                   placeholder="Valor" />
          </div>
        </div>
      </div>
      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalPag = false">
          <i class="bx bx-sync font-size-16 align-middle me-2"></i>
          Fechar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confPag">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>



  </Layout>
</template>

